import PostAddIcon from "@mui/icons-material/PostAdd";
import Container from "@mui/material/Container";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateItemButton from "../../../components/CreateItemButton.js";
import DataNotFound from "../../../components/DataNotFound.js";
import ErrorDialog from "../../../components/dialogs/ErrorDialog.js";
import LoadingBackdrop from "../../../components/LoadingBackdrop.js";
import PageList from "../../../components/page-list/PageList.js";
import { useUser } from "../../../components/UserContext.js";
import { getPlots } from "../../../lib/apiConfig.js";
import { PAGE_LIST_CONTAINER_SX, ROUTES } from "../../../lib/constants.js";
import { useFetch } from "../../../lib/hooks/useFetch.js";

export default function PlotsList({ locales }) {
  const { canEdit, runId } = useUser();
  const navigate = useNavigate();
  const [plots, setPlots] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const { isFetching } = useFetch({
    endpoint: getPlots({ runId }),
    mustFetch: !plots,
    onSuccess: setPlots,
    onFail: (error) => {
      setErrorMessage(error.message);
      setShowError(true);
    },
  });

  return isFetching ? (
    <LoadingBackdrop />
  ) : (
    <Container disableGutters sx={PAGE_LIST_CONTAINER_SX}>
      {canEdit && (
        <CreateItemButton
          icon={<PostAddIcon />}
          onClick={() =>
            navigate(`${ROUTES.PLOTS.BASE.replace(":runId", runId)}/${ROUTES.PLOTS.PLOTS.CREATE}`)
          }
          text={locales["plots.plots.create"]}
        />
      )}
      {Array.isArray(plots) ? (
        <PageList
          items={plots}
          locales={locales}
          pageName="plots"
          primaryTextProp="name"
          searchBoxLabel={locales["plots.plots.search"]}
          secondaryTextProp="writer.name"
        />
      ) : (
        <DataNotFound text={locales["plots.plots.notFound"]} />
      )}
      <ErrorDialog
        locales={locales}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage(null);
        }}
        show={showError}
      />
    </Container>
  );
}
